// extracted by mini-css-extract-plugin
module.exports = {"desktop_horizontal_scroll":"style_desktop_horizontal_scroll__rGoh_"};